module.exports = __webpack_public_path__ + "static/medallion_of_thoughts-086b44f80e6e806edf2457caba88311c.jpeg";